import { getStateHeadingData } from '../api/api';


// GET_State_Headings
export const getStateHeadings  = (stateHeadingsData) => ({
    type: 'GET_STATE_HEADINGS',
    data: stateHeadingsData
});

// SET_DIGITAL_CHARGED
export const setStateHeadings = (stateHeadingsData) => ({
    type: 'SET_STATE_HEADINGS',
    data: stateHeadingsData
});
export const starSetStateHeadings = (stateHeadingsData = {}) => {
    return (dispatch) => {
        dispatch(setStateHeadings(stateHeadingsData))
    }
};

export const starGetStateHeadings = (idBenef = '', idPartner = '') => {
    return () => {
        return getStateHeadingData(idBenef, idPartner);
    }
};


// WEBPACK FOOTER //
// ./src/actions/Dashboard.js